import ApprovalActionsModal from "../../../../../pages/Orders/view/ApprovalView/components/approvalDecisionsModal/ApprovalDecisionsModal";
import { ModalType } from "../../../../../pages/Orders/view/ApprovalView/types";

type RenderApprovalActionsModalProps = {
	activeModal: ModalType | null;
	setActiveModal: (modal: ModalType | null) => void;
	activeRowUuid: string;
	activeUuid: string;
	handleUpdateRowData: (uuid: string, key: string, newValue: any) => void;
	setDeactivatedQuickMenuIds: React.Dispatch<React.SetStateAction<string[]>>;
};

export const renderApprovalActionsModal = ({
	activeModal,
	setActiveModal,
	activeRowUuid,
	handleUpdateRowData,
	setDeactivatedQuickMenuIds,
}: RenderApprovalActionsModalProps) => {
	if (!activeModal) return null;

	let modalSelected = "";

	switch (activeModal) {
		case "approve":
			modalSelected = "approve";
			break;
		case "deny":
			modalSelected = "deny";
			break;
		case "assign":
			modalSelected = "assign";
			break;
		case "adminOnly":
			modalSelected = "adminOnly";
			break;
		default:
			return null;
	}

	return (
		<ApprovalActionsModal
			isOpen={true}
			onClose={() => setActiveModal(null)}
			modalSelected={modalSelected}
			updateRowData={handleUpdateRowData}
			setDeactivatedQuickMenuIds={setDeactivatedQuickMenuIds || []}
		/>
	);
};
